import { render, staticRenderFns } from "./StatisticTable.vue?vue&type=template&id=b96a8a84"
import script from "./StatisticTable.vue?vue&type=script&lang=ts"
export * from "./StatisticTable.vue?vue&type=script&lang=ts"
import style0 from "./StatisticTable.vue?vue&type=style&index=0&id=b96a8a84&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports